module.exports = __webpack_public_path__ + "img/wire-4.bd0ffa75.jpg";